import React, { FC } from 'react'
import { Link } from 'gatsby-plugin-react-i18next'
import clsx from 'clsx'
import ArrowRightIcon from './ArrowRightIcon'

export interface ISectionHeaderLinkCtaProps {
  linkUrl: string
  linkText: string
  onCtaClick?: (e: React.MouseEvent) => void
  ctaRef?: React.Ref<HTMLDivElement>
  className?: string
}

export const SectionHeaderLinkCta: FC<ISectionHeaderLinkCtaProps> = ({
  linkUrl,
  linkText,
  onCtaClick,
  ctaRef,
  className,
}) => {
  return (
    <div
      ref={ctaRef}
      className={clsx(
        'shrink-0 self-end',
        className
      )}
    >
      <Link
        to={linkUrl}
        className="group relative inline-flex items-center text-body-large md:text-title-medium lg:text-title-large xl:text-headline-small font-palanquin font-semibold text-on-surface select-none"
        onClick={onCtaClick}
      >
        <span
          className="inline-flex items-center text-primary opacity-100 translate-x-0 md:absolute md:left-none md:opacity-0 md:-translate-x-4 md:group-hover:translate-x-0 md:group-hover:opacity-100 transition-all duration-700 ease-[cubic-bezier(0.65,0,0.35,1)] shrink-0 pointer-events-none mr-2 md:mr-0"
          aria-hidden="true"
        >
          <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 xl:w-6 xl:h-6" />
        </span>
        <span className="inline-block border-b border-dashed border-primary pb-0.5 transition-transform duration-700 ease-[cubic-bezier(0.65,0,0.35,1)] md:group-hover:translate-x-7 xl:group-hover:translate-x-9">
          {linkText}
        </span>
      </Link>
    </div>
  )
}

export default SectionHeaderLinkCta
